module.exports = __webpack_public_path__ + "img/375.efec0ee3.jpg";